import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import Card from '../../components/Card';
import UserService from '../../services/user/UserService';
import DataTable from 'react-data-table-component';
import Negara from '../../utilities/Negara';
import { FaEdit, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Upi = () => {
    const columns = [
        {
            name: 'No Reg UPI',
            cell: row => row['upiRegNo'],
            grow: 0.6
        },
        {
            name: 'Tgl Reg UPI',
            cell: row => row['upiRegTgl'],
            grow: 0.5
        },
        {
            name: 'Nama UPI',
            cell: row => row['upiNama']
        },
        {
            name: 'Alamat UPI',
            cell: row => row['upiAlamat']
        },
        {
            name: 'Negara UPI',
            cell: row => <Negara id={row['upiNeg']} />,
            grow: 0.3
        },
        {
            name: 'Zonasi',
            cell: row => row['upiRegZonasi'],
            grow: 0.1
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    {
                        localStorage.getItem("kodeTrader") !== null &&
                        <div className="row">
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah Upi</Tooltip>}>

                                    <Button size="sm" variant="warning" onClick={() => handleClickEditUpi(row)}>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            )
        }
    ]

    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    const [listUpi, setlistUpi] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistUpi = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await userService.listUpiTrader(localStorage.getItem("kodeTrader") !== null ? localStorage.getItem("kodeTrader") : 0, null, page, size)
            setlistUpi(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistUpi([])
        }
        setLoading(false)
    }, [userService])

    useEffect(() => {
        getlistUpi(0, 10)
    }, [getlistUpi])

    const handleChangePage = (page) => {
        getlistUpi(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await userService.listUpiTrader(localStorage.getItem("kodeTrader") !== null ? localStorage.getItem("kodeTrader") : 0, null, page - 1, size)
        setlistUpi(_res.data.data)
        setSize(size)
    }

    const handleClickTambahUpi = () => {
        localStorage.removeItem("dataUpiStorage")
        navigate('/setting/upi-add-edit')
    }

    const handleClickEditUpi = (data) => {
        localStorage.removeItem("dataUpiStorage")
        localStorage.setItem("dataUpiStorage", JSON.stringify(data, null, 2))
        navigate('/setting/upi-add-edit')
    }

    const [valueSearch, setValueSearch] = useState(null)
    const [loadingSearch, setLoadingSearch] = useState(false)

    const onChangeSearch = e => {
        setValueSearch(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearch('')
        getlistUpi(0, 10)
    }

    const handleClickCari = async () => {
        setLoadingSearch(true)
        const _res = await userService.listUpiTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, valueSearch, 0, size)
        setlistUpi(_res.data.data)
        setTotalData(_res.data.totalData)
        setLoadingSearch(false)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama UPI</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNib" placeholder="Nama UPI" className="form-control-sm" value={valueSearch} onChange={onChangeSearch} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()} disabled={loadingSearch}>{loadingSearch && <Spinner />}Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar UPI</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {
                                localStorage.getItem("kodeTrader") !== null &&
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickTambahUpi()} ><FaPlus /> Tambah</Button>
                            }
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listUpi}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default Upi